import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BadgeDollarSign } from "lucide-react";
import { getLanguage } from "@/utils/languageUtils";
import { vehicleCardUILabels, leadUILabels } from "@/i18n";

interface PriceInfoSectionProps {
  expectedPrice: string;
  purchasePrice: string;
  marketPrice: string;
  title?: string;
}

export const PriceInfoSection = ({
  expectedPrice,
  purchasePrice,
  marketPrice,
  title,
}: PriceInfoSectionProps) => {
  const vehicleCardLabels = vehicleCardUILabels(getLanguage());
  const leadLabels = leadUILabels(getLanguage());
  const defaultTitle = title || vehicleCardLabels.priceInformation || leadLabels.priceInformation;
  
  return (
    <Card>
      <CardHeader className="p-3">
        <CardTitle className="flex items-center gap-2 text-lg text-green-400">
          <BadgeDollarSign className="h-5 w-5" />
          {defaultTitle}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-0 space-y-3">
        <div className="flex justify-center gap-12 text-sm">
          <div className="flex flex-col items-center">
            <span className="text-muted-foreground">
              {vehicleCardLabels.customerExpectedPrice || leadLabels.customerExpectedPrice}
            </span>
            <span className="font-medium">{expectedPrice}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-muted-foreground">
              {vehicleCardLabels.purchasePrice || leadLabels.purchasePrice}
            </span>
            <span className="font-medium">{purchasePrice}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-muted-foreground">
              {vehicleCardLabels.marketPrice || leadLabels.marketPrice}
            </span>
            <span className="font-medium">{marketPrice}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
